import React, { useState } from "react"
import { IMG } from "./common/CONST"
import * as TrinityAPI from "../requests/TrinityAPI"
import Button from "@/ui/components/Button"

interface IResetPasswordRequest {
  username: string
}

export const Forgot = () => {
  const [resetRequest, setResetRequest] = useState<IResetPasswordRequest>()
  const [codeSent, setCodeSent] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const submit = () => {
    if (!resetRequest?.username) return

    setLoading(true)

    TrinityAPI.sendResetCode(
      resetRequest,
      response => {
        if (response.status === 200) {
          setCodeSent(true)
        }
      },
      () => setLoading(false)
    )
  }

  return (
    <div className="registration-container">
      <div className="reg-left-img-block">
        <img src={IMG.main_logo} alt="" className="img-main-enter" />
      </div>
      <div className="reg-right-block">
        <div className="block-form">
          <h2 className="heading-form">Восстановить пароль</h2>
          {codeSent ? (
            <p className="text-block">
              Если e-mail был указан правильно, в течение 5 минут на него поступит ссылка для сброса пароля. Если письмо
              не приходит, проверьте папку "Спам"
            </p>
          ) : (
            <>
              <p className="text-block">
                Введите адрес электронной почты указанный при регистрации. Мы вышлем ссылку на сбор пароля
              </p>
              <fieldset>
                <legend>E-mail</legend>
                <input
                  type="email"
                  required
                  className="input-form"
                  placeholder="example@example.com"
                  onChange={e => setResetRequest({ ...resetRequest, username: e.target.value })}
                />
              </fieldset>
              <div className="flex-btn-justify">
                <Button type="submit" onClick={submit} loading={isLoading}>
                  Отправить
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
